module.exports = __webpack_public_path__ + "static/1-1920x1280-4b08498868dbc37e5c25f97623858c36.jpg";